import { render } from "./HomeTab.vue?vue&type=template&id=22f6f49d"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"
script.render = render

export default script